module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Kom i gang med ditt første belte","text":"Lynrask læring med morsomme husketeknikker"},"en":{"title":"Get started with your first belt","text":"Superfast learning with fun memory techniques"}}')
  delete Component.options._Ctor
}
